
import React, { useState } from 'react';
import { useInstructor } from '../context/InstructorContext';
import { Search, Filter } from 'lucide-react';

const MyStudents = () => {
    const { students, loading } = useInstructor();
    const [searchTerm, setSearchTerm] = useState('');

    const filteredStudents = students.filter(s =>
        s.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (loading) return (
        <div className="p-6 flex items-center justify-center h-screen">
            <div className="text-slate-400 font-bold uppercase tracking-widest text-xs animate-pulse">Loading Students...</div>
        </div>
    );

    return (
        <div className="p-6">
            <div className="bg-white rounded shadow p-6">
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '24px' }}>
                    <div style={{ position: 'relative', width: '300px' }}>
                        <Search size={18} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF' }} />
                        <input
                            type="text"
                            placeholder="Search students..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '10px 10px 10px 40px',
                                borderRadius: '6px',
                                border: '1px solid #e5e7eb',
                                outline: 'none'
                            }}
                        />
                    </div>
                    <button style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '10px 16px',
                        border: '1px solid #e5e7eb',
                        borderRadius: '6px',
                        backgroundColor: 'white',
                        color: '#374151',
                        fontWeight: '500'
                    }}>
                        <Filter size={18} />
                        Filter
                    </button>
                </div>

                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ borderBottom: '2px solid #f3f4f6' }}>
                            <th style={{ textAlign: 'left', padding: '12px', color: '#6B7280', fontSize: '13px', fontWeight: '600' }}>STUDENT</th>
                            <th style={{ textAlign: 'left', padding: '12px', color: '#6B7280', fontSize: '13px', fontWeight: '600' }}>PACKAGE</th>
                            <th style={{ textAlign: 'left', padding: '12px', color: '#6B7280', fontSize: '13px', fontWeight: '600' }}>PROGRESS</th>
                            <th style={{ textAlign: 'left', padding: '12px', color: '#6B7280', fontSize: '13px', fontWeight: '600' }}>LESSONS</th>
                            <th style={{ textAlign: 'left', padding: '12px', color: '#6B7280', fontSize: '13px', fontWeight: '600' }}>CONTACT</th>
                            <th style={{ textAlign: 'left', padding: '12px', color: '#6B7280', fontSize: '13px', fontWeight: '600' }}>ACTION</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredStudents.map(student => (
                            <tr key={student.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                                <td style={{ padding: '16px 12px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <div style={{
                                        width: '32px', height: '32px', borderRadius: '50%',
                                        backgroundColor: '#E0F2FE', color: '#0369A1',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        fontSize: '12px', fontWeight: 'bold'
                                    }}>{student.avatar}</div>
                                    <span style={{ fontWeight: '600', color: '#111827' }}>{student.name}</span>
                                </td>
                                <td style={{ padding: '16px 12px', color: '#4B5563' }}>{student.package || 'N/A'}</td>
                                <td style={{ padding: '16px 12px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <div style={{ flex: 1, height: '8px', backgroundColor: '#f3f4f6', borderRadius: '4px', overflow: 'hidden', minWidth: '80px' }}>
                                            <div style={{ width: `${student.progress}%`, height: '100%', backgroundColor: student.progress > 70 ? '#10b981' : '#6366f1' }}></div>
                                        </div>
                                        <span style={{ fontSize: '12px', fontWeight: 'bold' }}>{student.progress}%</span>
                                    </div>
                                </td>
                                <td style={{ padding: '16px 12px', color: '#4B5563' }}>{student.lessons_completed}</td>
                                <td style={{ padding: '16px 12px', color: '#4B5563' }}>{student.phone_number || student.email || 'N/A'}</td>
                                <td style={{ padding: '16px 12px' }}>
                                    <button style={{ color: '#6366f1', fontWeight: '600', fontSize: '13px', background: 'none' }}>View</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default MyStudents;
